import { v as vd } from "helpers/TestNullOrReturn";
import v from "helpers/TestNullOrReturn";
import {ParseYMDwDash} from "helpers/DateHelpers";

export default function PopulateClient(data) {
  return {
    ...vd("firstName", data.scd_name),
    lastName: v(data.scd_surname, ""),
    email: v(data.scd_email, ""),
    dateOfBirth:
      data.scd_dateOfBirth ? ParseYMDwDash(data.scd_dateOfBirth) : null,
    title: v(data.scd_title, "validationError"),
    occupation: v(data.scd_occupation, ""),
    monthlyIncome: v(data.scd_monthlyIncome, ""),
    smoker: v(data.scd_smoker, "validationError"),
    maritalStatus: v(data.scd_maritalStatus, "validationError"),
    qualification: v(data.scd_qualification, "validationError"),
    selfEmployed: v(data.scd_selfEmployed, "validationError"),
    salaryType: v(data.scd_salaryType, "validationError"),
    TaxDispensation: v(data.scd_taxDispensation, "validationError"),
    spouseIncome: v(data.scd_spouseIncome, ""),
    Admin: v(data.scd_pAdmin, ""),
    Travel: v(data.scd_pTravel, ""),
    ManualLabour: v(data.scd_pManual, ""),
    Supervision: v(data.scd_pSupervision, ""),
    gender: v(data.scd_gender, "validationError"),
    resAddressOne: v(data.scd_residentialAddress, ""),
    cellNumber: v(data.scd_cellNumber, ""),
    said: v(data.scd_saID, ""),
    actualMonthlyIncomeAT: v(data.scd_actualMonthlyIncomeAT, ""),

    clientType: v(data.scd_clientType, "validationError"),

    clientFileNumber: v(data.scd_clientFileNumber, ""),

    correspondenceType: v(data.scd_correspondenceType, "validationError"),

    correspondenceLanguage: v(
      data.scd_correspondenceLanguage,
      "validationError"
    ),

    correspondenceFormality: v(
      data.scd_correspondenceFormality,
      "validationError"
    ),

    nickName: v(data.scd_nickName, ""),

    initials: v(data.scd_initials, ""),

    secondNames: v(data.scd_secondAndOtherNames, ""),

    idType: v(data.scd_idType, "idNumber"),

    passportNumber: v(data.scd_passportNumber, ""),

    countryOfIssue: v(data.scd_countryOfIssue, ""),

    maidenName: v(data.scd_maidenName, ""),

    weddingDate:
      data.scd_weddingDate && data.scd_weddingDate.split("T")[0]
        ? data.scd_weddingDate.split("T")[0]
        : "",

    howMarried: v(data.scd_howMarried, "validationError"),

    taxNumber: v(data.scd_incomeTaxNumber, ""),

    telNumberHome: v(data.scd_TelNumberHome, ""),

    telNumberWork: v(data.scd_TelNumberWork, ""),

    resAddressTwo: v(data.scd_residentialAddress2, ""),

    resAddressThree: v(data.scd_residentialAddress3, ""),

    resAddressFour: v(data.scd_residentialAddress4, ""),

    postalCode: v(data.scd_postalCode, ""),

    qualificationName: v(data.scd_qualificationName, ""),

    healthHeight: v(data.scd_height, ""),

    healthWeight: v(data.scd_weight, ""),

    healthCurrentGp: v(data.scd_currentGp, ""),

    healthGpYears: v(data.scd_currentGpYears, ""),

    healthCurrentDentist: v(data.scd_currentDentist, ""),

    willHasWill: v(data.scd_hasWill, "validationError"),

    willExcecutor: v(data.scd_willExecutor, ""),

    willLocation: v(data.scd_wilLocation, ""),

    bankAccountName: v(data.sb_accountName, ""),

    bank: v(data.sb_bank, "validationError"),

    bankBranch: v(data.sb_branchName, ""),

    bankBranchCode: v(data.sb_branch, ""),

    bankAccNumber: v(data.sb_accountNumber, ""),
    
    bankAccountType: v(data.sb_accountType, "")
  };
}



// WEBPACK FOOTER //
// ./src/views/Clients/helpers/PopulateClient.js